// extracted by mini-css-extract-plugin
export default {"title":"FileInput_title__jXmnO"};